import type { File as SpotFile } from "@/types";

// What getSpotFileUrl resolves (a scheme) or returns (a path); anything else
// is text that landed on a file input, e.g. a literal saved before the input's
// type changed.
const FILE_URI = /^(spot|https?):\/\/|^data:|^\//;

function isSpotFileLike(value: unknown): value is { uri: string } {
  return (
    typeof value === "object" &&
    value !== null &&
    "uri" in value &&
    typeof value.uri === "string"
  );
}

function toSpotFile(value: unknown): SpotFile | undefined {
  if (isSpotFileLike(value)) {
    const name = "name" in value ? value.name : undefined;
    return { ...value, name: typeof name === "string" ? name : "" };
  }
  if (typeof value === "string" && FILE_URI.test(value)) {
    return { uri: value, name: "", content_type: "", size: 0 };
  }
  return undefined;
}

// Every file the picker can show from a saved value; values of another shape
// are dropped rather than rendered as a nameless row.
export function toSpotFiles(value: unknown): SpotFile[] {
  const items = Array.isArray(value) ? value : [value];
  return items.flatMap((item) => {
    const file = toSpotFile(item);
    return file ? [file] : [];
  });
}
